import React from 'react';
import { Plus, Edit, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { useNavigate } from 'react-router-dom';
const states = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];
const courses = [{
  name: 'Avoid The Oops: Contract Smarts for Agents',
  credit: '3 hrs. Contract Law',
  created: '02/11/2026',
  status: 'Section in progress'
}, {
  name: 'Deeds, Fires & Water: Be Prepared',
  credit: '3 hrs. General',
  created: '02/11/2026',
  status: 'Course enrolled'
}, {
  name: 'Follow All The Laws',
  credit: '3 hrs. Legal Issues',
  created: '02/11/2026',
  status: 'Course enrolled'
}, {
  name: 'A Letter From ADRE',
  credit: '3 hrs. Comm. Standards',
  created: '02/11/2026',
  status: 'Course enrolled'
}, {
  name: 'They Are A Protected Class',
  credit: '3 hrs. Fair Housing',
  created: '02/11/2026',
  status: 'Course enrolled'
}, {
  name: 'What Goes Wrong In Contracts',
  credit: '3 hrs. Contract Law',
  created: '02/11/2026',
  status: 'Course enrolled'
}, {
  name: 'Are They Represented?',
  credit: '3 hrs. Agency Law',
  created: '02/11/2026',
  status: 'Course completed'
}, {
  name: 'Your Clients Are Not Mushrooms',
  credit: '3 hrs. Disclosure',
  created: '02/11/2026',
  status: 'Course completed'
}, {
  name: 'Deeds, Fires & Water: Be Prepared',
  credit: '3 hrs. General',
  created: '12/31/2024',
  status: 'Course completed'
}, {
  name: 'Ethics & The Rules (with NAR Code of Ethics)',
  credit: '3 hrs. Comm. Standards',
  created: '12/31/2024',
  status: 'Course completed'
}, {
  name: 'No Secrets',
  credit: '3 hrs. Disclosure',
  created: '12/31/2024',
  status: 'Course enrolled'
}, {
  name: 'They Are A Protected Class',
  credit: '3 hrs. Fair Housing',
  created: '12/31/2024',
  status: 'Course enrolled'
}, {
  name: 'A Letter From ADRE',
  credit: '3 hrs. Comm. Standards',
  created: '12/31/2024',
  status: 'Course enrolled'
}, {
  name: 'Follow All The Laws',
  credit: '3 hrs. Legal Issues',
  created: '12/31/2024',
  status: 'Course enrolled'
}, {
  name: 'What Goes Wrong In Contracts',
  credit: '3 hrs. Contract Law',
  created: '12/31/2024',
  status: 'Course enrolled'
}, {
  name: 'Are They Represented?',
  credit: '3 hrs. Agency Law',
  created: '12/31/2024',
  status: 'Course enrolled'
}, {
  name: "Fair Housing In Today's World",
  credit: '3 hrs. Fair Housing',
  created: '12/13/2023',
  status: 'Course completed'
}, {
  name: 'Your Clients Are Not Mushrooms',
  credit: '3 hrs. Disclosure',
  created: '12/13/2023',
  status: 'Course completed'
}];
const courseOptions = ['NAR Code of Ethics (NO CE CREDIT)', 'Ethics & The Rules (with NAR Code of Ethics)', 'Deeds, Fires & Water: Be Prepared', 'Are They Represented?', 'Mastering Agency Agreements', 'A Letter From ADRE', "Don't Lose Your License", 'What Goes Wrong In Contracts', 'No Secrets', 'Follow All The Laws'];
export function EditUser() {
  const navigate = useNavigate();
  return <div className="space-y-4" data-id="element-938" data-mp="119ibcmpxsxbi">
      <div className="flex items-center justify-between" data-id="element-939" data-mp="11ajvrhsuew5w">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-940" data-mp="16839mglmp6xb">Edit User</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/users')} data-id="element-941" data-mp="16afrktrdzhad">
          ← Back to Users
        </Button>
      </div>

      <div className="flex flex-col lg:flex-row gap-6 items-start" data-id="element-942" data-mp="1k7uk47cxs56k">
        {/* Left: Profile form */}
        <Card className="flex-shrink-0 w-full lg:w-72" data-id="element-943" data-mp="1p54gy82nnj4f">
          <CardContent className="pt-4" data-id="element-944" data-mp="1txnx9csq8scx">
            <form className="space-y-3" data-id="element-945" data-mp="1u00m89wwk2zh">
              <Input label="Title" defaultValue="Mr" className="h-7 text-sm" data-id="element-946" data-mp="1yxijh31k4trn" />
              <Input label="First Name" defaultValue="Ryan" className="h-7 text-sm" data-id="element-947" data-mp="22ym21xazp3wk" />
              <Input label="Last Name" defaultValue="Loeding" className="h-7 text-sm" data-id="element-948" data-mp="27ygqzvb7fjez" />
              <Input label="Company" defaultValue="" className="h-7 text-sm" data-id="element-949" data-mp="3ngmsvvnywape" />
              <Input label="Address 1" defaultValue="2863 e park ave" className="h-7 text-sm" data-id="element-950" data-mp="3nir6x6fkyq3e" />
              <Input label="Address 2" defaultValue="" className="h-7 text-sm" data-id="element-951" data-mp="3eh0203sv6nal" />
              <Input label="City" defaultValue="gilbert" className="h-7 text-sm" data-id="element-952" data-mp="f2xlqeab0qg0" />
              <div data-id="element-953" data-mp="67q21heaf2hx">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-954" data-mp="6786yo3d2ubl">
                  State/Province *
                </label>
                <select defaultValue="Arizona" className="h-8 w-full rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-955" data-mp="17ls6a7vx60o">
                  {states.map(s => <option key={s} data-id="element-956" data-mp="1cv4cvdxof96y">{s}</option>)}
                </select>
              </div>
              <Input label="Zip" defaultValue="85234" className="h-7 text-sm" data-id="element-957" data-mp="1hvjnhxqkq2l8" />
              <Input label="Phone" defaultValue="6236958718" className="h-7 text-sm" data-id="element-958" data-mp="141iwxr9rzlvy" />
              <div data-id="element-959" data-mp="u44ghrnuqx3n">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-960" data-mp="u3l934vtvr3v">
                  Email
                </label>
                <input type="email" className="h-7 w-full rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-961" data-mp="z4iqvgcxej4u" />
                <p className="text-xs text-slate-500 mt-0.5" data-id="element-962" data-mp="p6un60xce1aj">
                  Leave blank to keep existing email (ryan@rykerrealstate.com)
                </p>
              </div>
              <Input label="Fax" defaultValue="" className="h-7 text-sm" data-id="element-963" data-mp="2ji9dojy6g4rc" />
              <Input label="How Did You Hear About Us" defaultValue="" className="h-7 text-sm" data-id="element-964" data-mp="7wh67t1hpk0o" />
              <Input label="Others" defaultValue="" className="h-7 text-sm" data-id="element-965" data-mp="hl8w7vmzpu8y" />
              <Input label="Facebook" defaultValue="yes" className="h-7 text-sm" data-id="element-966" data-mp="hnbwr9lrr5rx" />
              <div data-id="element-967" data-mp="rinbhrx6gczo">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-968" data-mp="ri3rm5nyvej0">
                  Username
                </label>
                <input type="text" className="h-7 w-full rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-969" data-mp="mmg2fq9hildi" />
                <p className="text-xs text-slate-500 mt-0.5" data-id="element-970" data-mp="32bhu5sp2yah9">
                  Leave blank to keep existing username (rloeding1)
                </p>
              </div>
              <div data-id="element-971" data-mp="2xe7t1fsbwadl">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-972" data-mp="2xer9st68ssq1">
                  Password
                </label>
                <input type="password" className="h-7 w-full rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-973" data-mp="2ghiufstiako2" />
                <p className="text-xs text-slate-500 mt-0.5" data-id="element-974" data-mp="2q6so3d400bea">
                  Leave blank to keep existing password
                </p>
              </div>
              <div className="py-1" data-id="element-975" data-mp="1xj6hrx3dysnq">
                <a href="#" className="text-blue-600 hover:underline text-xs" data-id="element-976" data-mp="1xk7us73ypp83">
                  Click here to obtain your license expiration date from ADRE
                </a>
              </div>
              <div data-id="element-977" data-mp="27if9skeoxx7g">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-978" data-mp="27ixe84bibhqg">
                  Available Courses
                </label>
                <input type="text" className="h-7 w-24 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-979" data-mp="3iwj45rp6xnd1" />
              </div>
              <div className="pt-2" data-id="element-980" data-mp="12bntllw336h1">
                <Button type="submit" size="sm" data-id="element-981" data-mp="12cp49p96tqy8">
                  Update
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>

        {/* Right: Course assignment + table */}
        <div className="flex-1 space-y-4 w-full" data-id="element-982" data-mp="oiogfqjrxocn">
          {/* Assign course */}
          <Card data-id="element-983" data-mp="oglhui4k2mwb">
            <CardContent className="pt-4" data-id="element-984" data-mp="jk4u3p19qajr">
              <div className="flex flex-wrap items-end gap-3" data-id="element-985" data-mp="jia5o0qsg0ax">
                <div data-id="element-986" data-mp="ek8pbnkqyf35">
                  <label className="block text-xs text-slate-600 mb-0.5" data-id="element-987" data-mp="eljotb75t0og">
                    Course
                  </label>
                  <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[220px]" data-id="element-988" data-mp="9nryumq2romw">
                    {courseOptions.map(c => <option key={c} data-id="element-989" data-mp="23xvopesrh0gt">{c}</option>)}
                  </select>
                </div>
                <div data-id="element-990" data-mp="1srwiwrkx3nm3">
                  <label className="block text-xs text-slate-600 mb-0.5" data-id="element-991" data-mp="1sqmj9xyf27dc">
                    Statuses
                  </label>
                  <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[160px]" data-id="element-992" data-mp="27o5i5t4t60yi">
                    <option data-id="element-993" data-mp="1ezgfvqs0npl6">Course Enrolled</option>
                    <option data-id="element-994" data-mp="1ey56nbfsxpmo">Course Completed</option>
                    <option data-id="element-995" data-mp="1a27ulhbkn5fp">Course in Progress</option>
                    <option data-id="element-996" data-mp="19zbxtwbgmmsu">Certificate Emailed</option>
                    <option data-id="element-997" data-mp="1oquiw8j6f7j2">Section in Progress</option>
                  </select>
                </div>
                <Button size="sm" variant="secondary" className="gap-1.5 border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" data-id="element-998" data-mp="1jxrnduuu9o08">
                  <Plus className="h-3.5 w-3.5 text-green-600" data-id="element-999" data-mp="r8uegicip3k5" />
                  Add
                </Button>
              </div>
            </CardContent>
          </Card>

          {/* Enrolled courses table */}
          <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1000" data-mp="2t04dxrwr96l7">
            <div className="overflow-x-auto" data-id="element-1001" data-mp="2sxrqiz88a40r">
              <table className="w-full text-sm text-left" data-id="element-1002" data-mp="2xy5zqklkfk0d">
                <thead className="bg-slate-800 text-white font-medium" data-id="element-1003" data-mp="2xwl56uz9412i">
                  <tr data-id="element-1004" data-mp="3lpbbankh3q4v">
                    <th className="px-3 py-3 border-r border-slate-700" data-id="element-1005" data-mp="3lmp78xwsjsre">
                      Course Name
                    </th>
                    <th className="px-3 py-3 border-r border-slate-700 w-36" data-id="element-1006" data-mp="3coljduyc2jwf">
                      Credit Type
                    </th>
                    <th className="px-3 py-3 border-r border-slate-700 text-center w-24" data-id="element-1007" data-mp="3gnufh6guitv5">
                      Created
                    </th>
                    <th className="px-3 py-3 text-center w-28" data-id="element-1008" data-mp="25a0d1saybkxw">
                      <div data-id="element-1009" data-mp="2585p054dvcpl">Actions</div>
                      <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-1010" data-mp="bs2pr65ceazg">
                        Edit | Delete
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200" data-id="element-1011" data-mp="20yb67jkws55">
                  {courses.map((c, i) => <tr key={i} className="hover:bg-slate-50" data-id="element-1012" data-mp="3t6zt901yom0a" data-mpi={i}>
                      <td className="px-3 py-2 border-r border-slate-200" data-id="element-1013" data-mp="3p663e14ykx4r">
                        {c.name}
                        <br data-id="element-1014" data-mp="3k6thpjptpw3r" />
                        <span className="text-slate-500 text-xs" data-id="element-1015" data-mp="3k6jqjst1liwh">
                          ({c.status})
                        </span>
                      </td>
                      <td className="px-3 py-2 border-r border-slate-200" data-id="element-1016" data-mp="3a9f21mbq5bci">
                        {c.credit}
                      </td>
                      <td className="px-3 py-2 border-r border-slate-200 text-center" data-id="element-1017" data-mp="1dflo8xrjzapt">
                        {c.created}
                      </td>
                      <td className="px-3 py-2 text-center" data-id="element-1018" data-mp="1gysro5najtts">
                        <div className="flex items-center justify-center gap-2" data-id="element-1019" data-mp="1gyayjhvxdvq3">
                          <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" data-id="element-1020" data-mp="1kz3aiiw6meq2">
                            <Edit className="h-4 w-4" data-id="element-1021" data-mp="1uqh5qeh3osde" />
                          </button>
                          <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-1022" data-mp="y0ghqhok2fx5">
                            <Trash2 className="h-4 w-4" data-id="element-1023" data-mp="170wk1ntkbh0f" />
                          </button>
                        </div>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </Card>
        </div>
      </div>
    </div>;
}